export default "__VITE_ASSET__Bj2dM6To__"